<template>
  <div class="document-page">
    <div class="content-wrapper">
      <!-- 左侧导航栏 -->
      <aside class="sidebar-left">
        <nav>
          <h2>文档目录</h2>
          <ul>
            <li>
              <a href="#" @click.prevent="showComponent('SoftwareIntro')">国产陆地卫星辐射校正软件</a>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('radCalibration')" class="nav-item">
                辐射定标
                <span :class="{'arrow': true, 'expanded': isExpandedRadCalibration}"></span>
              </a>
              <ul v-if="isExpandedRadCalibration">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('RadiationCalibration', 'rad-calibration-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('RadiationCalibration', 'rad-calibration-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('RadiationCalibration', 'rad-calibration-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('RadiationCalibration', 'rad-calibration-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('atmCorrection')" class="nav-item">
                大气校正
                <span :class="{'arrow': true, 'expanded': isExpandedAtmCorrection}"></span>
              </a>
              <ul v-if="isExpandedAtmCorrection">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('AtmosphericCorrection', 'atm-correction-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('AtmosphericCorrection', 'atm-correction-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('AtmosphericCorrection', 'atm-correction-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('AtmosphericCorrection', 'atm-correction-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('geoCorrection')" class="nav-item">
                几何校正
                <span :class="{'arrow': true, 'expanded': isExpandedGeoCorrection}"></span>
              </a>
              <ul v-if="isExpandedGeoCorrection">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('GeometricCorrection', 'geo-correction-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('GeometricCorrection', 'geo-correction-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('GeometricCorrection', 'geo-correction-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('GeometricCorrection', 'geo-correction-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('oneStopProcess')" class="nav-item">
                一站式处理
                <span :class="{'arrow': true, 'expanded': isExpandedOneStopProcess}"></span>
              </a>
              <ul v-if="isExpandedOneStopProcess">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('OneStopProcess', 'one-stop-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('OneStopProcess', 'one-stop-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('OneStopProcess', 'one-stop-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('OneStopProcess', 'one-stop-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('processingBatch')" class="nav-item">
                批处理
                <span :class="{'arrow': true, 'expanded': isExpandedProcessingBatch}"></span>
              </a>
              <ul v-if="isExpandedProcessingBatch">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('ProcessingBatch', 'batch-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('ProcessingBatch', 'batch-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('ProcessingBatch', 'batch-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('ProcessingBatch', 'batch-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('mosaicImage')" class="nav-item">
                图像镶嵌
                <span :class="{'arrow': true, 'expanded': isExpandedMosaicImage}"></span>
              </a>
              <ul v-if="isExpandedMosaicImage">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('MosaicImage', 'mosaic-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('MosaicImage', 'mosaic-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('MosaicImage', 'mosaic-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('MosaicImage', 'mosaic-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" @click.prevent="toggleExpansion('fusionImage')" class="nav-item">
                图像融合
                <span :class="{'arrow': true, 'expanded': isExpandedFusionImage}"></span>
              </a>
              <ul v-if="isExpandedFusionImage">
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('FusionImage', 'fusion-interface')"
                  >功能界面</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('FusionImage', 'fusion-params')"
                  >用户参数</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('FusionImage', 'fusion-steps')"
                  >操作步骤</a>
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="showComponent('FusionImage', 'fusion-results')"
                  >用户结果</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </aside>

      <!-- 主内容区域 -->
      <main class="main-content" ref="mainContentScrollArea">
        <component
          :is="currentComponent"
          :targetSectionId="targetSectionId"
          @scroll-to-section="handleScrollToSection"
        />
      </main>

      <!-- 右侧边栏 -->
      <aside class="sidebar-right">
        <section class="about-section">
          <h2>关于</h2>
          <p>采用先进的辐射传输模型，直接计算卫星影像对应的大气校正参数，构建卫星基础信息库和大气知识库，本程序受到国际版权保护。</p>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import SoftwareIntro from "./DocumentSections/SoftwareIntro.vue";
import RadiationCalibration from "./DocumentSections/RadiationCalibration.vue";
import AtmosphericCorrection from "./DocumentSections/AtmosphericCorrection.vue";
import GeometricCorrection from "./DocumentSections/GeometricCorrection.vue";
import OneStopProcess from "./DocumentSections/OneStopProcess.vue";
import ProcessingBatch from "./DocumentSections/ProcessingBatch.vue";
import MosaicImage from "./DocumentSections/MosaicImage.vue";
import FusionImage from "./DocumentSections/FusionImage.vue";

export default {
  name: "DocumentPage",
  components: {
    SoftwareIntro,
    RadiationCalibration,
    AtmosphericCorrection,
    GeometricCorrection,
    OneStopProcess,
    ProcessingBatch,
    MosaicImage,
    FusionImage
  },
  data() {
    return {
      currentComponent: "SoftwareIntro",
      targetSectionId: null,
      isExpandedRadCalibration: false,
      isExpandedAtmCorrection: false,
      isExpandedGeoCorrection: false,
      isExpandedOneStopProcess: false,
      isExpandedProcessingBatch: false,
      isExpandedMosaicImage: false,
      isExpandedFusionImage: false
    };
  },
  methods: {
    toggleExpansion(section) {
      switch (section) {
        case "radCalibration":
          this.isExpandedRadCalibration = !this.isExpandedRadCalibration;
          break;
        case "atmCorrection":
          this.isExpandedAtmCorrection = !this.isExpandedAtmCorrection;
          break;
        case "geoCorrection":
          this.isExpandedGeoCorrection = !this.isExpandedGeoCorrection;
          break;
        case "oneStopProcess":
          this.isExpandedOneStopProcess = !this.isExpandedOneStopProcess;
          break;
        case "processingBatch":
          this.isExpandedProcessingBatch = !this.isExpandedProcessingBatch;
          break;
        case "mosaicImage":
          this.isExpandedMosaicImage = !this.isExpandedMosaicImage;
          break;
        case "fusionImage":
          this.isExpandedFusionImage = !this.isExpandedFusionImage;
          break;
      }
    },
    showComponent(componentName, sectionId = null) {
      this.currentComponent = componentName;
      this.targetSectionId = sectionId;
    },
    handleScrollToSection(sectionId) {
      this.$nextTick(() => {
        const mainContent = this.$refs.mainContentScrollArea;
        if (mainContent && sectionId) {
          const element = mainContent.querySelector(`#${sectionId}`);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          } else {
            mainContent.scrollTop = 0;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
:root {
  --primary: #00b4ff;
  --secondary: #00f7ff;
  --accent: #ff00ff;
  --text-primary: #e0e0ff;
  --text-secondary: #b0b0ff;
  --card-bg: rgba(10, 10, 15, 0.8);
  --bg-dark: #0a0a0f;
}

.document-page {
  display: flex;
  justify-content: center;
  padding: 30px 20px;
  font-family: "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial,
    sans-serif;
  background-color: var(--bg-dark);
  color: var(--text-primary);
  line-height: 1.6;
}

.document-page > .content-wrapper {
  display: flex;
  max-width: 1400px;
  width: 100%;
  border: 1px solid rgba(var(--primary), 0.3);
  background-color: var(--card-bg);
  box-shadow: 0 0 25px rgba(var(--primary), 0.2);
  border-radius: 12px;
  overflow: hidden;
}

/* 左侧导航栏样式 */
.sidebar-left {
  flex: 0 0 280px;
  padding: 30px 25px;
  background-color: rgba(var(--card-bg), 0.8);
  border-right: 1px solid rgba(var(--primary), 0.2);
}

.sidebar-left h2 {
  color: var(--primary);
  font-size: 22px;
  margin-bottom: 25px;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(var(--primary), 0.5);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.sidebar-left ul {
  list-style: none;
  padding: 0;
}

.sidebar-left ul li {
  margin-bottom: 8px;
}

.sidebar-left ul li a {
  text-decoration: none;
  color: var(--text-secondary);
  padding: 8px 10px;
  display: block;
  transition: background-color 0.3s, color 0.3s, text-shadow 0.3s;
  border-radius: 4px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-size: 14px;
}

.sidebar-left ul li a:hover {
  background-color: rgba(var(--primary), 0.15);
  color: var(--primary);
  text-shadow: 0 0 5px rgba(var(--primary), 0.5);
}

.sidebar-left ul li a.nav-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px;
  font-weight: 500;
}

.arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--text-secondary);
  transition: transform 0.3s ease;
}

.arrow.expanded {
  transform: rotate(180deg);
}

.sidebar-left ul ul {
  padding-left: 20px;
  margin-top: 5px;
  border-left: 2px solid rgba(var(--primary), 0.4);
}

.sidebar-left ul ul li a {
  padding: 6px 10px;
  font-size: 13px;
  font-weight: normal;
}

/* 主内容区域样式 */
.main-content {
  flex-grow: 1;
  padding: 40px;
  background-color: rgba(var(--card-bg), 0.6);
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  position: relative;
  scroll-behavior: smooth;
}

.main-content h1 {
  color: var(--primary);
  font-size: 32px;
  margin-bottom: 20px;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(var(--primary), 0.6);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.3;
}

.main-content h2 {
  color: var(--primary);
  font-size: 24px;
  margin: 30px 0 15px 0;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(var(--primary), 0.5);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.4;
}

.main-content h3 {
  color: var(--secondary);
  font-size: 20px;
  margin: 25px 0 12px 0;
  font-weight: 600;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.4;
}

.main-content h4 {
  color: var(--text-primary);
  font-size: 18px;
  margin: 20px 0 10px 0;
  font-weight: 600;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.4;
}

.main-content .creation-info {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(var(--primary), 0.2);
  padding-bottom: 15px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.main-content section {
  margin-bottom: 40px;
}

.main-content p {
  line-height: 1.8;
  margin-bottom: 20px;
  color: var(--text-primary);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-size: 15px;
  text-indent: 2em;
  text-align: justify;
}

/* 特殊段落样式（如引言、总结等） */
.main-content p.lead {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  background-color: rgba(var(--primary), 0.1);
  padding: 15px 20px;
  border-left: 4px solid var(--primary);
  border-radius: 0 8px 8px 0;
  margin: 25px 0;
  text-indent: 0;
}

.main-content p.highlight {
  background-color: rgba(var(--secondary), 0.1);
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid rgba(var(--secondary), 0.3);
  margin: 20px 0;
  text-indent: 0;
}

.software-interface-mockup {
  border: 1px solid rgba(var(--primary), 0.3);
  padding: 25px;
  margin: 35px 0;
  background-color: rgba(var(--card-bg), 0.4);
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(var(--primary), 0.1);
}

.software-interface-mockup h3 {
  font-size: 20px;
  margin-bottom: 25px;
  text-align: center;
  color: var(--primary);
  font-weight: bold;
  text-shadow: 0 0 8px rgba(var(--primary), 0.5);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.input-section,
.output-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.input-section label,
.output-section label {
  width: 120px;
  flex-shrink: 0;
  font-weight: bold;
  color: var(--text-primary);
  font-size: 15px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.input-section input,
.output-section input {
  flex-grow: 1;
  padding: 10px 15px;
  border: 1px solid rgba(var(--primary), 0.4);
  background-color: rgba(0, 0, 0, 0.4);
  color: var(--text-primary);
  border-radius: 5px;
  margin-right: 15px;
  font-size: 15px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.input-section input::placeholder,
.output-section input::placeholder {
  color: var(--text-secondary);
  opacity: 0.7;
}

.input-section button,
.output-section button {
  padding: 10px 20px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: var(--text-primary);
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px rgba(var(--primary), 0.4);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-weight: 500;
}

.input-section button:hover,
.output-section button:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 15px rgba(var(--primary), 0.6);
}

.radio-options {
  margin-bottom: 20px;
  display: flex;
  gap: 30px;
  justify-content: center;
}

.radio-options label {
  font-size: 15px;
  color: var(--text-primary);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.radio-options input[type="radio"] {
  margin-right: 8px;
}

.image-previews {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  min-height: 250px;
}

.input-image-preview,
.output-image-preview {
  flex: 1;
  border: 1px dashed rgba(var(--primary), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  color: var(--text-secondary);
  font-size: 16px;
  border-radius: 8px;
  box-shadow: inset 0 0 10px rgba(var(--secondary), 0.2);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

/* 右侧边栏样式 */
.sidebar-right {
  flex: 0 0 260px;
  padding: 30px 25px;
  background-color: rgba(var(--card-bg), 0.8);
  border-left: 1px solid rgba(var(--primary), 0.2);
}

.sidebar-right h2 {
  color: var(--primary);
  font-size: 22px;
  margin-bottom: 25px;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(var(--primary), 0.5);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.sidebar-right section {
  margin-bottom: 40px;
}

.sidebar-right p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
  margin-bottom: 15px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  text-indent: 1.5em;
}

.sidebar-right ul {
  list-style: none;
  padding: 0;
}

.sidebar-right ul li {
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--text-secondary);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.sidebar-right ul li:last-child {
  margin-bottom: 0;
}

/* List Styles (Ordered and Unordered) */
.main-content ol,
.main-content ul {
  list-style: none;
  padding-left: 20px;
  margin: 20px 0;
  counter-reset: list-item;
}

.main-content ol li,
.main-content ul li {
  margin-bottom: 12px;
  color: var(--text-primary);
  line-height: 1.7;
  position: relative;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-size: 15px;
  text-indent: 0;
  padding-left: 25px;
}

.main-content ol li strong,
.main-content ul li strong {
  color: var(--primary);
  text-shadow: 0 0 5px rgba(var(--primary), 0.4);
  font-weight: 600;
}

.main-content ol li::before {
  content: counter(list-item) ". ";
  counter-increment: list-item;
  color: var(--secondary);
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  text-align: right;
  text-shadow: 0 0 5px rgba(var(--secondary), 0.5);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

/* 子列表样式调整 */
.main-content ol li ul {
  counter-reset: none;
  margin-top: 8px;
  margin-bottom: 8px;
}

.main-content ol li ul li {
  margin-bottom: 8px;
  padding-left: 20px;
}

.main-content ol li ul li::before {
  content: "\2705";
  color: var(--secondary);
  font-size: 1.1em;
  position: absolute;
  left: 0;
  top: 0;
  text-shadow: 0 0 5px rgba(var(--secondary), 0.5);
}

/* 表格样式 */
.main-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background-color: rgba(var(--card-bg), 0.6);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(var(--primary), 0.3);
}

.main-content table th {
  background-color: rgba(var(--primary), 0.2);
  color: var(--primary);
  padding: 12px 15px;
  text-align: left;
  font-weight: bold;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-size: 15px;
  border-bottom: 1px solid rgba(var(--primary), 0.3);
}

.main-content table td {
  padding: 12px 15px;
  border-bottom: 1px solid rgba(var(--primary), 0.1);
  color: var(--text-primary);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

.main-content table tr:hover {
  background-color: rgba(var(--primary), 0.05);
}

/* 代码块样式 */
.main-content pre {
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(var(--primary), 0.3);
  border-radius: 6px;
  padding: 15px;
  margin: 20px 0;
  overflow-x: auto;
  font-family: "Consolas", "Monaco", "Courier New", monospace;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-primary);
}

.main-content code {
  background-color: rgba(var(--primary), 0.1);
  color: var(--secondary);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: "Consolas", "Monaco", "Courier New", monospace;
  font-size: 13px;
}

/* 引用块样式 */
.main-content blockquote {
  border-left: 4px solid var(--primary);
  background-color: rgba(var(--primary), 0.1);
  padding: 15px 20px;
  margin: 20px 0;
  border-radius: 0 6px 6px 0;
  font-style: italic;
  color: var(--text-secondary);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-size: 14px;
  line-height: 1.7;
}

/* 自定义滚动条样式 */
.main-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.main-content::-webkit-scrollbar-track {
  background: rgba(var(--primary), 0.1);
  border-radius: 4px;
}

.main-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(var(--primary), 0.5);
}

.main-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, var(--secondary), var(--primary));
  box-shadow: 0 0 15px rgba(var(--primary), 0.7);
}

/* 右侧边栏滚动条 */
.sidebar-right::-webkit-scrollbar {
  width: 6px;
}

.sidebar-right::-webkit-scrollbar-track {
  background: rgba(var(--primary), 0.1);
  border-radius: 3px;
}

.sidebar-right::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  border-radius: 3px;
  box-shadow: 0 0 8px rgba(var(--primary), 0.4);
}

.sidebar-right::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, var(--secondary), var(--primary));
  box-shadow: 0 0 12px rgba(var(--primary), 0.6);
}

/* 左侧导航栏滚动条 */
.sidebar-left::-webkit-scrollbar {
  width: 6px;
}

.sidebar-left::-webkit-scrollbar-track {
  background: rgba(var(--primary), 0.1);
  border-radius: 3px;
}

.sidebar-left::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  border-radius: 3px;
  box-shadow: 0 0 8px rgba(var(--primary), 0.4);
}

.sidebar-left::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, var(--secondary), var(--primary));
  box-shadow: 0 0 12px rgba(var(--primary), 0.6);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .document-page > .content-wrapper {
    flex-direction: column;
  }

  .sidebar-left,
  .sidebar-right {
    flex: none;
    width: 100%;
  }

  .main-content {
    padding: 30px 20px;
  }
}

@media (max-width: 768px) {
  .document-page {
    padding: 15px 10px;
  }

  .main-content {
    padding: 20px 15px;
  }

  .main-content h1 {
    font-size: 24px;
  }

  .main-content h2 {
    font-size: 20px;
  }

  .main-content p {
    font-size: 14px;
    text-indent: 1.5em;
  }
}
</style>
